<template>
  <div>
    <div class="body-2 pb-2">
      Many of the most popular eye-related ICD10 codes are listed below. You can
      also search for codes using the above search box or
      <a href="/icd10/chapters">browse through all 70,000 ICD codes</a>.
    </div>
    <v-container>
      <v-row align="start" class="full-height">
        <v-col v-for="(item, index) in items" :key="index" class="fill-height">
          <v-card
            outlined
            class="fill-height"
            min-height="250"
            max-height="100%"
          >
            <v-card-title class="pa-2 titleBkg">
              <a
                text
                :href="`/icd10/${item.href}`"
                class="titleLink link mx-auto"
                >{{ item.title }}</a
              ></v-card-title
            >
            <v-card-text class="pt-4 d-flex flex-row">
              <div class="textSection">
                <div
                  v-for="(section, sectionIndex) in item.sections"
                  :key="sectionIndex"
                >
                  <a :href="`/icd10/${section.href}`" class="link">{{
                    section.title
                  }}</a>
                </div>
              </div>
              <!-- {{ imagePath + item.image }} -->
              <v-img
                v-if="item.image"
                :src="imagePath + item.image + '.svg'"
                max-height="140"
                max-width="100"
                class="my-2 mx-auto"
              ></v-img>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
// import Name from "../dir/file";

export default {
  name: "IcdHome",
  props: {},
  data: function () {
    return {
      imagePath: "https://www.eyedock.com/images/pathologies/",
      items: [
        {
          title: "Vision",
          href: "H52,H53,H54?title=Vision",
          image: "vision",
          sections: [
            { title: "Refractive Error", image: null, href: "H52" },
            { title: "Accommodation", image: null, href: "H52.5" },
            { title: "Amblyopia", image: null, href: "H53.0" },
            { title: "Anisometropia", image: null, href: "H52.3" },
            { title: "Color Vision", image: null, href: "H53.5" },
            { title: "Subjective Vision", image: null, href: "H53.1" },
            { title: "Low Vision", image: null, href: "H54" },
            { title: "Visual Field Defects", image: null, href: "H53.4" },
          ],
        },
        {
          title: "Strabismus, EOMs",
          href: "H50,H51,H49,H55?title=Strabismus and EOMs",
          image: "eoms",
          sections: [
            {
              title: "Convergence Disorders",
              image: null,
              href: "H51.1",
            },
            { title: "Cranial Nerve Palsies", image: null, href: "H49" },
            { title: "Diplopia", image: null, href: "H53.2" },
            { title: "Nystagmus", image: null, href: "H55" },
            { title: "Strabismus", image: null, href: "H50" },
          ],
        },

        {
          title: "Eyelids",
          href: "H00-H03,H57.8?title=Eyelids",
          image: "lids",
          sections: [
            { title: "Blepharitis", image: null, href: "H01.0" },
            {
              title: "Ectropion",
              image: null,
              href: "H02.1",
            },
            {
              title: "Entropion & Trichiasis",
              image: null,
              href: "H02.0",
            },
            { title: "Hordeolum and chalazion", image: null, href: "H00" },
            {
              title: "Meibomian gland dysfunction",
              image: null,
              href: "H02.88",
            },

            { title: "Ptosis", image: null, href: "H02.4" },
          ],
        },
        {
          title: "Lacrimal",
          href: "H04",
          image: "lacrimal",
          sections: [
            { title: "Dacryocystitis", image: null, href: "H04.3,H04.4" },

            { title: "Dry eye syndrome", image: null, href: "H04.12" },
            { title: "Epiphora", image: null, href: "H04.2" },
            { title: "Stenosis ", image: null, href: "H04.5" },
          ],
        },
        {
          title: "Conjunctiva, Sclera/Episclera",
          href: "H10-H11,H15?title=Conjunctiva, Sclera, and Episclera",
          image: "conjunctiva",
          sections: [
            { title: "Conjunctival abrasion", image: null, href: "S05.0" },

            { title: "Conjunctivitis", image: null, href: "H10" },

            { title: "GPC", image: null, href: "H10.41" },
            { title: "Pinguecula ", image: null, href: "H11.15" },
            { title: "Pterygium ", image: null, href: "H11.0" },
            { title: "Subconjunctival heme ", image: null, href: "H11.3" },
            { title: "Scleritis", image: null, href: "H15.0" },

            { title: "Episcleritis", image: null, href: "H15.1" },
            { title: "Staphyloma", image: null, href: "H15.8" },
          ],
        },
        // {
        //   title: "Sclera/Episclera",
        //   href: "H15",
        //   image: null,
        //   sections: [
        //     { title: "Scleritis", image: null, href: "H15.0" },

        //     { title: "Episcleritis", image: null, href: "H15.1" },
        //     { title: "Staphyloma", image: null, href: "H15.8" },
        //   ],
        // },
        {
          title: "Cornea",
          href: "H16-H18,S05.0?Title=Cornea",
          image: "cornea",
          sections: [
            { title: "Abrasion", image: null, href: "S05.0" },
            { title: "Dystrophies", image: null, href: "H18.5" },
            { title: "Edema", image: null, href: "H18.2" },

            { title: "Foreign body", image: null, href: "T15.0" },
            { title: "Neovascularization", image: null, href: "H16.4" },

            { title: "Keratoconjunctivitis", image: null, href: "H16.2" },
            { title: "Keratoconus", image: null, href: "H18.6" },

            { title: "Punctate keratitis (SPK)", image: null, href: "H16.14" },
            { title: "Scars and opacities", image: null, href: "H17" },
            { title: "Ulcer", image: null, href: "H16.0" },
          ],
        },
        {
          title: "Iris, Pupils",
          href: "H19-H22,H57.0?title=Iris, Ciliary Body, and Pupils",
          image: "iris",
          sections: [
            { title: "Iritis", image: null, href: "H20" },
            { title: "Hyphema", image: null, href: "H21.0" },
            { title: "Rubeosis", image: null, href: "H21.1" },
            {
              title: "Anisocoria, Miosis, Mydriasis",
              image: null,
              href: "H57.0",
            },
          ],
        },
        {
          title: "Lens, Cataract",
          href: "H25-H28",
          image: "cataract",
          sections: [
            { title: "Aphakia", image: null, href: "H27.0" },
            { title: "Cortical cataract", image: null, href: "H25.01" },
            {
              title: "Anterior subcapsular cataract",
              image: null,
              href: "H25.03",
            },
            {
              title: "Posterior subcapsular cataract",
              image: null,
              href: "H25.04",
            },
            {
              title: "Nuclear cataract",
              image: null,
              href: "H25.1",
            },
          ],
        },
        {
          title: "Retina and Choroid",
          href: "H30-H36",
          image: "macula",
          sections: [
            { title: "Chorioretinal scars", image: null, href: "H31.0" },
            { title: "Diabetic Retinopathy", image: null, href: "diabetes" },
            { title: "Epiretinal membrane (ERM)", image: null, href: "H35.37" },
            { title: "Macular Degeneration", image: null, href: "H35.3" },
            { title: "Macular Hole", image: null, href: "H35.34" },
            { title: "Nevii", image: null, href: "D31.2,D31.3" },
            { title: "Retinal detachment", image: null, href: "H33.0" },
            { title: "Retinoschisis", image: null, href: "H33.1" },
            { title: "Vascular occlusions", image: null, href: "H34" },
          ],
        },
        {
          title: "Vitreous Humor",
          href: "H43",
          image: "vitreous",
          sections: [
            { title: "Asteroid hyalosis", image: null, href: "H43.2" },
            { title: "Floaters", image: null, href: "H43.3" },
            { title: "Hemorrhage", image: null, href: "H43.1 " },
            { title: "Vitreomacular adhesion", image: null, href: "H43.82" },
            {
              title: "Posterior detachment (PVD)",
              image: null,
              href: "H43.8",
            },
          ],
        },

        {
          title: "Optic Nerve and Pathways",
          href: "H46-H47",
          image: "pathways",
          sections: [
            { title: "Coloboma", image: null, href: "H47.31" },
            { title: "ONH drusen", image: null, href: "H47.32" },
            { title: "Neuritis and Neuropathy", image: null, href: "H46" },
            { title: "Optic atrophy", image: null, href: "H47.2" },
            { title: "Papilledema", image: null, href: "H47.1" },
          ],
        },
        {
          title: "Glaucoma",
          href: "H40-H42",
          image: "glaucoma",
          sections: [
            {
              title: "Low-tension glaucoma (LTG)",
              image: null,
              href: "H40.12",
            },
            {
              title: "Open-angle glaucoma (POAG)",
              image: null,
              href: "H40.11",
            },
            { title: "Glaucoma Suspect", image: null, href: "H40.0" },
            {
              title: "Pigmentary glaucoma",
              image: null,
              href: "H40.13",
            },
            {
              title: "Pseudoexfoliation",
              image: null,
              href: "H40.14 ",
            },
          ],
        },
        {
          title: "Globe & Orbit",
          href: "H05,H44?title=Globe and Orbit",
          image: null,
          sections: [
            { title: "Degenerative myopia", image: null, href: "H44.2" },
            { title: "Endophthalmitis", image: null, href: "H44.0-H44.1" },
            { title: "Enophthalmos", image: null, href: "H05.4" },
            { title: "Proptosis", image: null, href: "H05.2" },
          ],
        },
        // {
        //   title: "Low Vision & Field Defects",
        //   image: null,
        //   sections: [

        //   ],
        // },
      ],
    };
  },
  methods: {},
  computed: {},
  metaInfo() {
    return {
      title: "EyeDock/ICD10 | codes relevant to eye care",
    };
  },
};
</script>

<style scoped>
.titleLink {
  font-weight: 600;
}
.link {
  text-decoration: none;
  color: #1976d2;
}

.link:hover {
  text-decoration: none;
  color: #0d3156;
}
.titleBkg {
  background-color: #f3f8fa;
  border-bottom: 1px solid #e5ebed;
  line-height: 1em;
}

.textSection {
  min-width: 165px;
}
</style>
